import { Caja } from './caja';

export class DetalleCaja {
  id: number;
  caja: Caja;
  tipoMovimiento: String;
  descripcion: String;
  importe: number;
  constructor() {
    this.caja = new Caja();

  }

}